<h3 mat-dialog-title class="text-align">{{data.text}}</h3>
<mat-dialog-actions class="actions-container">
    <button mat-raised-button class="button" [mat-dialog-close]="false" cdkFocusInitial>{{data.negative}}</button>
    <button mat-raised-button class="button" color="primary" [mat-dialog-close]="true">{{data.confirmative}}</button>
</mat-dialog-actions>